<div class="menu-1" *ngIf="Heading">
  <!-- <div class="menu-1" *ngIf="Heading"> -->
  <span class="menu-heading">{{ Heading }}</span>
  <span class="close" (click)="closeCaseCreation()">X</span>
</div>
<div class="container">
  <div *ngIf="showSearch == true">
    <!-- <app-search-dialog (selectedSearchedItem)="handleSelectedUser($event)" [hideNotFoundButton]="false"></app-search-dialog> -->
    <app-search-dialog
    (selectedSearchedItem)="handleSelectedUser($event)"
    (notFoundAddNew)="handleSelectedUserNotFound($event)" [hideNotFoundButton]="false"
  ></app-search-dialog>
  </div>
  <div class="row create-screen" *ngIf="showCreateCase == true">
    <div class="user-case">
      Creating Case for {{ fullName }}
      <span class="change-user" (click)="changeUser()">
        <img alt="" class="edit-img" src="{{ baseHref }}/assets/images/icon-pen-edit.png" />Change User</span
      >
      </div>
    <div style="
    /* margin: -11px 0 0 0; */
    padding: 0px 46px 0px 0px;
">
      <app-cases  
      [ReadOnly]="ReadOnly"
      [activityId]="activityId"
      [selectedCaseId]="selectedCaseId"
      [userId]="selectedUserID ? selectedUserID : 0"
      [isCreateNewCase]= "isCreateNewCase"
      (formDataEmitter)="onChildFormData($event, 'cases')"
      (formDataHasError)="handleFormDataHasError($event, 'cases')"
     
    >
    </app-cases>
    </div>
   
    
    <div class="btn-wrapper text-end mt-3 mb-3">
      <button class="outline-btn ms-2" type="submit" value="Cancel" (click)="cancel()">Cancel</button>

      <button class="main-btn ms-2" type="submit" value="Submit" (click)="confirm()" [disabled]="formDataValid" >Submit</button>
     
    </div>
  </div>
</div>
